/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Form_Aria_LabelInputs */

const en_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and Replace Form`)
};

const fr_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de recherche et remplacement`)
};

const de_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen und Ersetzen Formular`)
};

const it_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di ricerca e sostituzione`)
};

const ru_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма поиска и замены`)
};

const es_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de búsqueda y reemplazo`)
};

const zh_cn2_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索和替换表单`)
};

const ja_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索と置換フォーム`)
};

const hi_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज और प्रतिस्थापन प्रपत्र`)
};

const pt_pt2_find_replace_form_aria_label = /** @type {(inputs: Find_Replace_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de busca e substituição`)
};

/**
* | output |
* | --- |
* | "Search and Replace Form" |
*
* @param {Find_Replace_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_form_aria_label = /** @type {((inputs?: Find_Replace_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_form_aria_label(inputs)
	if (locale === "de") return de_find_replace_form_aria_label(inputs)
	if (locale === "it") return it_find_replace_form_aria_label(inputs)
	if (locale === "ru") return ru_find_replace_form_aria_label(inputs)
	if (locale === "es") return es_find_replace_form_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_form_aria_label(inputs)
	if (locale === "ja") return ja_find_replace_form_aria_label(inputs)
	if (locale === "hi") return hi_find_replace_form_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_form_aria_label(inputs)
	return en_find_replace_form_aria_label(inputs)
});